import { useEffect, useState, useRef  } from 'react'
import { useLocation, useParams } from 'react-router-dom';
import axios from 'axios';
import useModalStore from '../../../zustand/store/useModalStore';
import useConfirm from '../../../hooks/useConfirm';
import useQueryLinkNavigate from '../../../hooks/useQueryLinkNavigate';

import '../../../css/data-grid.css';

const NewBoardWrite = ({boardTypeCode}) => {
    
    const { nttSno } = useParams();
    const { writeTyp, returnPage } = useQueryLinkNavigate();
    const boardContents = useLocation().state?.contents;
    const prevSearch = useLocation().state?.prevSearch;
    
    const username = localStorage.getItem('name');

    // toast modal open function
    const showNotiModal = useModalStore(state => state.showNotiModal);

    // confirm hook
    const confirm = useConfirm();

    const [detailData, setDetailData] = useState([{}]);

    const [insertData, setInsertData] = useState({
        mstSno : boardTypeCode,
        altType : writeTyp,
        nttTypCod: '',
        nttTil : '',
        nttCotClob : '',
        nttSno : nttSno || '',
        noticecheck: 'N',
        nttPwd : '',
        PWDYN : 'N'
    });

    const notiTyp = boardTypeCode === 11;
    const docTyp = boardTypeCode === 3;
    const workTyp = boardTypeCode === 14;

    const addTyp = writeTyp === '01';
    const modTyp = writeTyp === '02';
    const repTyp = writeTyp === '03';
    // 이미 비밀글인 글을 고칠 때는 비밀번호를 비워도 된다(원래 비밀번호 유지)
    const keepPwd = modTyp && detailData?.bbsCommon?.pwdyn === 'Y';

    const getBoardDetailData = async () => {
        try {    
            const response = await axios.get('/commonapi/selectBoardDetail.do',
                { params: {mstSno: boardTypeCode, nttSno: nttSno} }
            );
            setDetailData(response.data);
            const detailData = {
                ...insertData,
                nttTil: modTyp ? response.data.bbsCommon.nttTil : '',
                nttTypCod: response.data.bbsCommon.nttTypCod,
                noticecheck: response.data.bbsCommon.noticecheck,
                nttSttDte: response.data.bbsCommon.noticestartday,
                nttEndDte: response.data.bbsCommon.noticeendday,
                // 수정할 때는 지금 비밀글 여부를 채운다. 비밀번호 칸을 비우면 서버가 원래 비밀번호를 그대로 둔다
                PWDYN: modTyp && response.data.bbsCommon.pwdyn === 'Y' ? 'Y' : 'N',
            };
            setInsertData(detailData);
        } catch (e) {
            console.error('board detail data 로딩 중 오류 발생', e);
        }
    };

    const oEditorsRef = useRef([]);     // SmartEditor2가 채워주는 레퍼런스
    const createdRef = useRef(false);   // 중복 생성 방지
    const editorCreated = useRef(false);

    const write = async () => {
        try {
            const boardType = notiTyp ? '공지사항' : docTyp ? '자료실' : '업무공유';
            const altTypeTxt = repTyp ? '답글 등록' : modTyp ?  '수정' : '등록';

            const ok = await confirm(boardType +' 내용을 '+altTypeTxt+'하시겠습니까?');
            if(!ok) return false;
            
            oEditorsRef.current.getById['nttCot'].exec('UPDATE_CONTENTS_FIELD', []);
            
            const nttCotValue = document.getElementById('nttCot').value;
            
            if(workTyp && (insertData.nttTypCod === null || insertData.nttTypCod === undefined || insertData.nttTypCod === '')) {
                showNotiModal('게시글 타입은 필수입니다.');
                return false;
            };

            if(insertData.PWDYN === 'Y' && !keepPwd && (insertData.nttPwd === null || insertData.nttPwd === undefined || insertData.nttPwd === '')) {
                showNotiModal('비밀글 사용 시 비밀번호는 필수입니다.');
                return false;
            }
            
            if(insertData.noticecheck === 'Y'
                && ((insertData.nttSttDte === null || insertData.nttSttDte === undefined)
                || (insertData.nttEndDte === null || insertData.nttEndDte === undefined)
                || (insertData.nttEndDte === '' || insertData.nttEndDte === ''))) {
                    showNotiModal('공지글 사용 시 공지기간은 필수입니다.');
                    return false;
            };

            if(insertData.nttTil === null || insertData.nttTil === '' || insertData.nttTil === undefined) {
                showNotiModal('게시글 제목은 필수입니다.');
                return false;
            };

            if(nttCotValue === null || nttCotValue === '' || nttCotValue === undefined || nttCotValue === '<br>') {
                showNotiModal('게시글 내용은 필수입니다.');
                return false;
            };

            const requestData = {
                ...insertData,
                nttCotClob: nttCotValue,
            };
            const formData = new FormData();
            for (const [key, value] of Object.entries(requestData)) {
                formData.append(key, value);
            }

            const response = await axios.post('/commonapi/board_register.do', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            const keyValue = await axios.get('/commonapi/getBoardKeyValue.do');

            if(response) {
                showNotiModal(altTypeTxt+'이 완료되었습니다.');
                if(modTyp) {
                    returnPage('detail', nttSno, prevSearch);
                } else {
                    if(keyValue) {
                        returnPage('detail', keyValue.data - 1, prevSearch);
                    }
                }
            }

        } catch(e) {
            console.error('board insert/modify 중 오류 발생', e);
        }
    }

    useEffect(() => {
        if (createdRef.current) return;
        if (!addTyp) getBoardDetailData();
        // 함수 정의
        const smartEditor = function (boardContents) {
            if(!editorCreated.current) {
                if(window.nhn?.husky?.EZCreator) {
                    window.nhn.husky.EZCreator.createInIFrame({
                        oAppRef: oEditorsRef.current,
                        elPlaceHolder: 'nttCot',
                        sSkinURI: '../../../plugin/smarteditor2.0/SmartEditor2Skin.html',
                        fOnAppLoad: () => {
                            if(modTyp) {
                                oEditorsRef.current.getById['nttCot'].setIR(boardContents);
                            }
                        },
                        fCreator: 'createSEditor2',
                    });
                    editorCreated.current = true;
                };
            }
        }
        // 실행
        smartEditor(boardContents);
    }, [addTyp]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...insertData,
            [name]: value
        };
        setInsertData(newParams);
    };
    
    useEffect(() => {
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = '';
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    
    const saveBtnRef = useRef(null);
    const fileBtnRef = useRef(null);

    useEffect(() => {
        // 스마트에디터 iframe 로드 후
        const timer = setTimeout(() => {
            const editorWrapper = document.querySelector('.smart_editor');
            if (!editorWrapper) return false;

            // 상위 iframe 확인
            const mainIframe = editorWrapper.querySelector('iframe');
            if (!mainIframe || !mainIframe.contentWindow) return false;

            const mainDoc = mainIframe.contentDocument || mainIframe.contentWindow.document;

            // iframe 내부 툴바 영역 button 수집
            const toolbarButtons = mainDoc.querySelectorAll(
                `.se2_tool .se2_text_tool > ul > li > button,
                .se2_tool .se2_text_tool > ul > .se2_pair > span > button,
                .se2_tool .se2_action > ul > li > button,
                .se2_tool .se2_multy_image > button`
            );

            if (toolbarButtons.length === 0) return false;

            if (toolbarButtons.length > 0) {
                // 사용자가 Tab을 누르면 바로 본문 쪽으로 이동하기 위해 첫번째 버튼 외 tab 진입 막기 (-1 처리)
                toolbarButtons.forEach((btn, idx) => {
                    if (idx !== 0) {
                        btn.setAttribute('tabindex', '-1');
                    }
                });

                // 툴바 내부는 좌/우 방향키로 이동 처리
                toolbarButtons.forEach((btn, idx) => {
                    btn.addEventListener('keydown', (e) => {
                        if (e.key === 'ArrowRight') {
                            e.preventDefault();
                            const nextBtn = toolbarButtons[idx + 1] || toolbarButtons[0]; // 끝이면 처음으로 루프
                            nextBtn.focus();
                        }
                        if (e.key === 'ArrowLeft') {
                            e.preventDefault();
                            const prevBtn = toolbarButtons[idx - 1] || toolbarButtons[toolbarButtons.length - 1]; // 처음이면 끝으로 루프
                            prevBtn.focus();
                        }
                        if(e.key === 'Tab' && e.shiftKey) {
                            e.preventDefault();
                            fileBtnRef.current.focus();
                        }
                    });
                });
            }

            // 상위 iframe 안에 본문 iframe 확인
            const editorIframe = mainDoc.querySelector('iframe');

            if (editorIframe && editorIframe.contentWindow) {
                const iframeDoc = editorIframe.contentDocument || editorIframe.contentWindow.document;
                // 에디터 실제 본문 텍스트 입력 구역 (body 태그)
                const editorBody = iframeDoc.querySelector('.se2_inputarea') || iframeDoc.body;

                // 🎯 동선 1: 툴바 영역에서 [Tab]을 누르면 ➡️ 본문 내부로 강제 진입
                // (개선안이 적용되어 툴바 내부 버튼 중 활성화된 곳 어디서든 Tab을 누르면 본문으로 들어갑니다)
                if (toolbarButtons.length > 0) {
                    toolbarButtons.forEach((btn) => {
                        btn.addEventListener('keydown', (e) => {
                            if (e.key === 'Tab' && !e.shiftKey) {
                                e.preventDefault();
                                if (editorBody) editorBody.focus(); // 본문 텍스트 입력창으로 워프
                            }
                        });
                    });
                }

                // 🎯 본문 내부 키보드 제어 (들여쓰기 완전 분쇄 및 탈출)
                if (editorBody) {
                    editorBody.addEventListener('keydown', (e) => {
                        
                        // 🎯 동선 2: 본문 내부에서 [Tab]을 누르면 ➡️ 하단 탭(Editor, HTML, TEXT 등)으로 정상 탈출
                        if (e.key === 'Tab' && !e.shiftKey) {
                            e.preventDefault();
                            e.stopPropagation(); // 에디터 자체 들여쓰기 스크립트 실행 방어
                            
                            // 하단 모드 변환 툴바의 첫 버튼(보통 Editor 나 크기조절 핸들러 부근)을 찾습니다.
                            const bottomTab = iframeDoc.querySelector('.se2_conversion_mode button');
                            if (bottomTab) {
                                bottomTab.focus();
                            } else if (saveBtnRef.current) {
                                saveBtnRef.current.focus(); // 하단 탭이 구조상 실패하면 최종 수비대인 저장 버튼으로 토스
                            }
                        }

                        // 🎯 동선 3 (역주행): 본문 내부에서 [Shift + Tab]을 누르면 ➡️ 툴바 영역으로 백트래킹
                        if (e.key === 'Tab' && e.shiftKey) {
                            e.preventDefault();
                            e.stopPropagation();
                            // 툴바 그룹 중 포커스가 허용된 첫 번째 버튼(글꼴)으로 안전하게 돌려보냅니다.
                            if (toolbarButtons.length > 0) toolbarButtons[0].focus(); 
                        }
                    }, { capture: true }); // 에디터 내장 탭 차단 기능보다 우선순위를 먼저 가로채는 옵션
                }

                // 🎯 동선 4 (역주행): 하단 변환 탭에서 [Shift + Tab]을 누르면 ➡️ 다시 내용 본문으로 진입
                const bottomFirstTab = editorWrapper.querySelector('.se2_text_tool, #se2_conversion_mode_editor');
                if (bottomFirstTab) {
                    bottomFirstTab.addEventListener('keydown', (e) => {
                        if (e.key === 'Tab' && e.shiftKey) {
                            e.preventDefault();
                            if (editorBody) editorBody.focus(); // 본문 입력창으로 복귀
                        }
                    });
                }
            }
        }, 1200);

        return () => clearTimeout(timer);
    }, []);
    
    return (
        <>
            <div className='board_action flex flex-col gap-3 w-full h-full'>
                <div className='com-search board overflow-auto'>
                    <table>
                        <colgroup>
                            <col width='10%' />
                            <col width='40%' />
                            <col width='10%' />
                            <col width='40%' />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>분류</th>
                                <td>
                                    <div className='flex gap-3 items-center'>
                                        <p className='whitespace-no-wrap'>{notiTyp ? '공지사항' : docTyp ? '자료실' : '업무공유게시판'}</p>
                                        {workTyp && 
                                            <select
                                                id='nttTypCod'
                                                name='nttTypCod'
                                                value={insertData.nttTypCod}
                                                onChange={handleInputChange}
                                                disabled={repTyp}
                                            >
                                                <option value=''>=== 게시글 타입 ===</option>
                                                <option value='12'>권역외상센터</option>
                                                <option value='10'>외상등록체계(입력)</option>
                                                <option value='06'>외상등록체계(시스템)</option>
                                                <option value='02'>표준등록체계(입력)</option>
                                                <option value='05'>표준등록체계(시스템)</option>
                                            </select>
                                        }
                                    </div>
                                </td> 
                                <th>작성자</th>
                                <td>
                                    {modTyp ? (detailData?.bbsCommon?.nttUsrNick || detailData?.bbsCommon?.nttUsrNam) : username}
                                </td> 
                            </tr>
                            <tr>
                                <th>{workTyp ? '비밀글 여부' : '공지기간 사용여부'}</th>
                                <td>
                                    <div className='flex gap-2'>
                                        <div className='flex'>
                                            <input type='radio' name={workTyp ? 'PWDYN' : 'noticecheck'} id={`${workTyp ? 'pwd' : 'notice_check'}_y`}
                                                value='Y'
                                                checked={(workTyp ? insertData.PWDYN : insertData.noticecheck) === 'Y'}
                                                onChange={handleInputChange}
                                            />
                                            <label htmlFor={`${workTyp ? 'pwd' : 'notice_check'}_y`}>사용</label>
                                        </div>
                                        <div className='flex'>
                                            <input type='radio' name={workTyp ? 'PWDYN' : 'noticecheck'} id={`${workTyp ? 'pwd' : 'notice_check'}_n`}
                                                value='N'
                                                checked={(workTyp ? insertData.PWDYN : insertData.noticecheck) === 'N'}
                                                onChange={handleInputChange}
                                            />
                                            <label htmlFor={`${workTyp ? 'pwd' : 'notice_check'}_n`}>미사용</label>
                                        </div>
                                    </div>
                                </td>
                                <th>{workTyp ? '비밀번호' : '공지기간'}</th>
                                <td>
                                    {workTyp ?
                                        <input
                                            type='password'
                                            className='input_style'
                                            id='nttPwd'
                                            name='nttPwd'
                                            onChange={handleInputChange}
                                            value={insertData.nttPwd}
                                            placeholder={keepPwd ? '비워 두면 원래 비밀번호 유지' : ''}
                                            disabled={insertData.PWDYN === 'N'}
                                        />
                                    :
                                        <>
                                            <input
                                                type='date'
                                                name='nttSttDte'
                                                defaultValue={detailData?.bbsCommon?.noticestartday}
                                                onChange={handleInputChange}
                                                disabled={insertData.noticecheck === 'N'}
                                            />
                                            &nbsp;~&nbsp;
                                            <input
                                                type='date'
                                                name='nttEndDte'
                                                defaultValue={detailData?.bbsCommon?.noticeendday}
                                                onChange={handleInputChange}
                                                disabled={insertData.noticecheck === 'N'}
                                            />
                                        </>
                                    }
                                </td>
                            </tr>
                            <tr>
                                <th>제목</th>
                                <td colSpan='5'>
                                    <input type='text' className='input_style' id='nttTil' name='nttTil' onChange={handleInputChange} value={insertData.nttTil} />
                                </td> 
                            </tr>
                            <tr>
                                <th>첨부파일</th>
                                <td colSpan='3'>
                                    <div className='flex flex-col gap-1 mb-1 w-fit'>
                                        <input type='file' id='addFileName1' name='addFileName1'/>
                                        <input type='file' id='addFileName2' name='addFileName2'/>
                                        <input type='file' id='addFileName3' name='addFileName3' ref={fileBtnRef}/>
                                    </div>
                                    <div>
                                        <span className='text-xs co_red'>
                                            * 첨부파일명은 확장자를 포함하여 최대 80자 이내로 등록해주세요.<br />
                                            * 첨부파일은 최대 3개까지 가능하며, 첨부할 파일이름에 빈공간이 없는 파일이름으로 바꾸어 올려주시기 바랍니다.<br />
                                            * 내용이 4000자 이내로 제한되오니, 그 이상의 등록을 원하시면 첨부파일로 등록해주세요.<br />
                                            * 첨부파일의 용량은 100MB로 제한 되오니 참고하시기 바랍니다.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>내용</th>
                                <td colSpan='5' className='p-0'>
                                    <div className='smart_editor'>
                                        <textarea id='nttCot' name='nttCot' onChange={handleInputChange} className='smart_editor_width' rows='10' cols='10' data-reqmsg='내용'></textarea>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='btn_container flex gap-2 justify-center'>
                    <button ref={saveBtnRef} onClick={() => write()} className='comm_btn bg_ho_primary'>{modTyp ? '수정' : '등록'}</button>
                    <button onClick={() => addTyp ? returnPage('list') : returnPage('detail', nttSno, prevSearch)} className='comm_btn_w'>취소</button>
                </div>
            </div>
        </>
    )
}

export default NewBoardWrite;